import type { FC } from "react";
import { useEffect } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBlocNext } from "@blac/react";
import DataHub from "src/ui/components/DataHub/DataHub";
import LabResultGroupTable from "src/ui/components/LabResultGroupTable";

const UserLabResults: FC = () => {
  const [{ observationBundles }, { loadObservationBundles }] = useBlocNext(
    ObservationBundleBloc
  );

  useEffect(() => {
    void loadObservationBundles();
  }, []);

  return (
    <>
      {/* Data Hub */}
      <DataHub />

      <nine-spacer s="lg" />
      <nine-spacer s="xs" />

      {/* List lab results — limit is applied after EXCLUDED bundles are
          filtered out, so hidden bundles never consume visible slots. */}
      <LabResultGroupTable observationBundles={observationBundles} limit={20} />
    </>
  );
};

export default UserLabResults;
